// SheetJS runs in a worker so large workbook parsing does not freeze the page.
// file-loader emits the installed SheetJS build as a same-origin static asset.
// eslint-disable-next-line import/no-webpack-loader-syntax
import sheetJsUrl from "file-loader!xlsx/dist/xlsx.full.min.js";

export const PACKAGE_IMPORT_CHUNK_SIZE = 1000;

// This function is serialized into a Blob worker. Keep it self-contained.
export function packageImportWorker(scope) {
  var sheet, mapping, headers, lastRow, cursor, expectedRows, chunkIndex;
  var chunkSize = 1000;
  function text(value) { return value === null || value === undefined ? "" : String(value).trim(); }
  function mobile(value) {
    var number = text(value).replace(/[\s\-()]/g, "");
    if (number.indexOf("+94") === 0) { number = number.slice(3); }
    else if (number.indexOf("94") === 0) { number = number.slice(2); }
    else if (number.indexOf("0") === 0) { number = number.slice(1); }
    return /^[0-9]{9}$/.test(number) ? "+94" + number : "";
  }
  function pad(value) { return String(value).padStart(2, "0"); }
  function date(value) {
    if (!text(value)) { return ""; }
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      return value.getFullYear() + "-" + pad(value.getMonth() + 1) + "-" + pad(value.getDate());
    }
    if (typeof value === "number") {
      var parsed = scope.XLSX.SSF.parse_date_code(value);
      if (parsed) { return parsed.y + "-" + pad(parsed.m) + "-" + pad(parsed.d); }
    }
    var input = text(value);
    var timestamp = input.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}):(\d{2}):(\d{2})(?:\.\d+)?(?:Z|[+-](\d{2}):?(\d{2}))?$/);
    if (timestamp) {
      if (+timestamp[2] > 23 || +timestamp[3] > 59 || +timestamp[4] > 59
        || (timestamp[5] && (+timestamp[5] > 23 || +timestamp[6] > 59))) {
        throw new Error("Invalid date of birth: invalid time in timestamp.");
      }
      // A birth date is a calendar date. Do not shift it when a timestamp has a timezone.
      input = timestamp[1];
    }
    var parts = input.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/);
    if (parts) { input = parts[3] + "-" + pad(parts[2]) + "-" + pad(parts[1]); }
    if (!/^\d{4}-\d{2}-\d{2}$/.test(input)) { throw new Error("Invalid date of birth: use DD/MM/YYYY, YYYY-MM-DD or YYYY-MM-DD HH:mm:ss."); }
    var check = new Date(input + "T12:00:00Z");
    if (Number.isNaN(check.getTime()) || check.toISOString().slice(0, 10) !== input) { throw new Error("Invalid date of birth."); }
    return input;
  }
  function normalized(values) {
    function field(name) { return mapping[name] ? values[headers.indexOf(mapping[name])] : ""; }
    var gender = text(field("gender")).toLowerCase();
    if (gender === "m") { gender = "male"; }
    if (gender === "f") { gender = "female"; }
    if (gender === "o" || gender === "other") { gender = "others"; }
    if (gender && ["male", "female", "others"].indexOf(gender) === -1) { throw new Error("Unknown gender: " + gender); }
    return {
      mobile_no: mobile(field("mobile_no")), name: text(field("name")),
      email: text(field("email")).toLowerCase(), policy_number: text(field("policy_number")),
      gender: gender, date_of_birth: date(field("date_of_birth")),
      package_name: text(field("package_name")),
    };
  }
  function block(start) {
    var end = Math.min(lastRow, start + chunkSize - 1);
    return scope.XLSX.utils.sheet_to_json(sheet, {
      header: 1, defval: "", blankrows: true,
      range: { s: { r: start, c: 0 }, e: { r: end, c: headers.length - 1 } },
    });
  }
  function present(values) { return values.some(function (value) { return text(value) !== ""; }); }
  scope.onmessage = function (event) {
    try {
      var message = event.data;
      if (message.type === "init") {
        if (!scope.XLSX) { scope.importScripts(message.sheetJsUrl); }
        var workbook = scope.XLSX.read(message.buffer, { type: "array", cellDates: true });
        sheet = workbook.Sheets[workbook.SheetNames[0]];
        if (!sheet || !sheet["!ref"]) { throw new Error("The first worksheet is empty."); }
        var range = scope.XLSX.utils.decode_range(sheet["!ref"]);
        headers = scope.XLSX.utils.sheet_to_json(sheet, {
          header: 1, range: { s: { r: 0, c: 0 }, e: { r: 0, c: range.e.c } },
        })[0].map(text);
        mapping = message.mapping;
        Object.keys(mapping).forEach(function (field) {
          if (mapping[field] && headers.indexOf(mapping[field]) === -1) { throw new Error("Mapped column is missing: " + mapping[field]); }
        });
        if (!mapping.package_name) { throw new Error("Map the Package Name column first."); }
        lastRow = range.e.r;
        var titles = Object.create(null), seen = Object.create(null), errors = [], total = 0;
        message.packageTitles.forEach(function (title) { titles[title] = (titles[title] || 0) + 1; });
        for (var start = 1; start <= lastRow; start += chunkSize) {
          block(start).forEach(function (values, index) {
            if (!present(values)) { return; }
            total += 1;
            try {
              var data = normalized(values);
              if (titles[data.package_name] !== 1) { throw new Error("Unknown or ambiguous package name: " + data.package_name); }
              var keys = [];
              if (data.mobile_no) { keys.push("mobile:" + data.mobile_no); }
              if (data.email) { keys.push("email:" + data.email); }
              if (!keys.length) { throw new Error("Missing mobile number or email. Policy number is reference only."); }
              keys.forEach(function (key) {
                if (seen[key]) { throw new Error("Duplicate " + (key.indexOf("mobile:") === 0 ? "mobile number" : "email") + "; first seen on row " + seen[key] + "."); }
              });
              keys.forEach(function (key) { seen[key] = start + index + 1; });
            } catch (error) {
              if (errors.length < 20) { errors.push("Row " + (start + index + 1) + ": " + error.message); }
            }
          });
          scope.postMessage({ type: "validating", percent: Math.min(100, Math.round((start + chunkSize) / (lastRow + 1) * 100)) });
        }
        if (errors.length) { throw new Error(errors.join("\n")); }
        if (!total) { throw new Error("No customer rows found."); }
        expectedRows = total; cursor = 1; chunkIndex = 0;
        scope.postMessage({ type: "ready", expectedRows: total, totalChunks: Math.ceil(total / chunkSize) });
      } else if (message.type === "next") {
        var rows = [];
        while (cursor <= lastRow && rows.length < chunkSize) {
          // Never materialize a second full copy of the workbook's rows.
          var end = Math.min(lastRow, cursor + (chunkSize - rows.length) - 1);
          var valuesBlock = scope.XLSX.utils.sheet_to_json(sheet, {
            header: 1, defval: "", blankrows: true,
            range: { s: { r: cursor, c: 0 }, e: { r: end, c: headers.length - 1 } },
          });
          valuesBlock.forEach(function (values, index) {
            if (present(values)) {
              rows.push({ row_number: cursor + index + 1, status: "valid", normalized: normalized(values), errors: [] });
            }
          });
          cursor = end + 1;
        }
        if (rows.length) { scope.postMessage({ type: "chunk", rows: rows, chunkIndex: chunkIndex++, expectedRows: expectedRows }); }
        else { scope.postMessage({ type: "done" }); }
      }
    } catch (error) { scope.postMessage({ type: "error", message: error.message }); }
  };
}

export function createPackageImportWorker() {
  const source = new Blob([`(${packageImportWorker.toString()})(self);`], { type: "application/javascript" });
  const url = URL.createObjectURL(source);
  const worker = new Worker(url);
  URL.revokeObjectURL(url);
  return { worker, sheetJsUrl: new URL(sheetJsUrl, window.location.href).href };
}

export function importRequestId() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
